import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialExperienceManagerData: IExperienceManagerState = {
  data: {
    manager: [],
    meta: {},
  },
  deleteSuccess: false,
  loading: false,
  success: false,
}

export interface IExperienceManagerState {
  data?: {
    manager?: []
    meta?: {[key: string]: number}
  }
  activateSuccess?: boolean
  deactivateSuccess?: boolean
  importSuccess?: boolean
  singleActivateSuccess?: boolean
  singleDeactivateSuccess?: boolean
  deleteSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IExperienceManagerState = initialExperienceManagerData,
  action: ActionWithPayload<IExperienceManagerState>
) => {
  switch (action.type) {
    case actionTypes.GET_EXPERIENCE_MANAGER_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_EXPERIENCE_MANAGER_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_EXPERIENCE_MANAGER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_EXPERIENCE_MANAGER_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_EXPERIENCE_MANAGER_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_EXPERIENCE_MANAGER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_EXPERIENCE_MANAGER_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    case actionTypes.UPDATE_EXPERIENCE_MANAGER_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_EXPERIENCE_MANAGER_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_EXPERIENCE_MANAGER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.DELETE_EXPERIENCE_MANAGER_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_EXPERIENCE_MANAGER_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_EXPERIENCE_MANAGER_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    case actionTypes.SINGLE_ACTIVATE_EXPERIENCE_MANAGER_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_EXPERIENCE_MANAGER_SUCCESS: {
      return {...state, activateSuccess: true, loading: false}
    }
    case actionTypes.SINGLE_ACTIVATE_EXPERIENCE_MANAGER_FINISH: {
      return {...state, activateSuccess: false, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_EXPERIENCE_MANAGER_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_DEACTIVATE_EXPERIENCE_MANAGER_SUCCESS: {
      return {...state, deactivateSuccess: true, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_EXPERIENCE_MANAGER_FINISH: {
      return {...state, deactivateSuccess: false, loading: false}
    }

    case actionTypes.SORT_EXPERIENCE_MANAGER_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_EXPERIENCE_MANAGER_SUCCESS: {
      return {
        ...state,
        sortExperienceManagerData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_EXPERIENCE_MANAGER_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_EXPERIENCE_MANAGER_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortExperienceManagerData: [],
      }
    }

    case actionTypes.IMPORT_EXPERIENCE_MANAGER_START: {
      return {...state, loading: true}
    }

    case actionTypes.IMPORT_EXPERIENCE_MANAGER_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        loading: false,
        importSuccess: true,
      }
    }

    case actionTypes.IMPORT_EXPERIENCE_MANAGER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false, importSuccess: false}
    }

    default:
      return state
  }
}
